/**
 * Formatage des surfaces parcellaires.
 *
 * Vit dans `lib/` et non dans une page : `formatSurface` est utilisé par une
 * dizaine d'écrans, dont `AppShellLayout` qui est monté sur TOUTES les routes
 * authentifiées. Tant qu'il était exporté depuis `pages/vignoble/ParcellesList`,
 * le shell tirait cette page — et ses dépendances — dans le chunk d'entrée.
 * Audit perf 2026-07-25.
 */

/** Affichage exact en hectares/ares, sans troisième unité ni arrondi. */
export function formatSurface(ares: string | number): string {
  const valeur = String(ares).trim().replace(",", ".");
  const parties = /^(\d+)(?:\.(\d+))?$/.exec(valeur);
  if (!parties) return "—";
  const aresEntiers = BigInt(parties[1]!);
  const hectares = String(aresEntiers / 100n).padStart(2, "0");
  const reste = String(aresEntiers % 100n).padStart(2, "0");
  const fraction = parties[2]?.replace(/0+$/, "");
  return `Ha${hectares}Ar${reste}${fraction ? `,${fraction.padEnd(2, "0")}` : ""}`;
}

/** Compatibilité des appelants de totaux : même format exact que les parcelles. */
export function formatSurfaceHectares(ares: string | number): string {
  return formatSurface(ares);
}

/** La saisie reste textuelle jusqu'à validation, notamment pendant « 12, ». */
export function lireSurfaceAres(valeur: string): number | null {
  const normalisee = valeur.trim().replace(",", ".");
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalisee)) return null;
  const surface = Number(normalisee);
  return Number.isFinite(surface) && surface > 0 ? surface : null;
}
